// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + {"102":"xlsx","133":"pdfmake","182":"canvg"}[chunkId] + "." + {"102":"c141374c","133":"fb647ec6","182":"ce05afdf"}[chunkId] + ".chunk.js";
};